const contactInfo = [
    {
        icon: 'call',
        name: 'Call Me',
        data: '+91 63880 49949'
    },
    {
        icon: 'email',
        name: 'Email',
        data: 'himanshuseth.in@gmail.com'
    },
    {
        icon: 'place',
        name: 'Location',
        data: 'Prahlad Ghat,Varanasi'
    }
];

export default contactInfo; 